import { Controller } from 'stimulus'
import { throttle, debounce } from 'throttle-debounce'

let renderGrid, GiphyFetch

import './giphy_component.css'

export default class extends Controller {
  static targets = ['grid', 'spinner', 'input']

  static values = {
    noGifMsg: String,
  }

  async connect() {
    this.disconnected = false
    renderGrid = (await import('@giphy/js-components')).renderGrid
    GiphyFetch = (await import('@giphy/js-fetch-api')).GiphyFetch

    if (this.disconnected) return

    // create a GiphyFetch with your api key
    // apply for a new Web SDK key. Use a separate key for every platform (Android, iOS, Web)
    this.gf = new GiphyFetch('NCC6TJOWR0OpxfWkTeLql4TMaT4bhNSx')
    this.renderGrid()
  }

  disconnect() {
    this.disconnected = true
  }

  // Creating a grid with window resizing and remove-ability
  makeGrid = (targetEl) => {
    const self = this
    let width = 392
    let columns = 3
    let gutter = 6

    if (screen.width < 768) {
      width = 200
      columns = 2
      gutter = 3
    }

    const render = () => {
      this.hideLoader()
      return renderGrid(
        {
          width: width,
          fetchGifs: self.fetchGifs,
          columns: columns,
          gutter: gutter,
          hideAttribution: true,
          noLink: true,
          onGifClick: self.onGifSelect,
          noResultsMessage: self.noGifMsgValue,
        },
        targetEl
      )
    }
    const resizeRender = throttle(500, render)
    window.addEventListener('resize', resizeRender, false)
    const remove = render()
    return {
      remove: () => {
        remove()
        window.removeEventListener('resize', resizeRender, false)
      },
    }
  }

  fetchGifs = (offset) => {
    if (this.inputTarget.value.length > 0) {
      return this.gf.search(this.inputTarget.value, {
        sort: 'relevant',
        limit: 12,
        type: 'gifs',
      })
    } else {
      return this.gf.trending({ offset, limit: 12 })
    }
  }

  renderGrid = debounce(300, () => {
    this.grid?.remove()
    this.showLoader()
    this.grid = this.makeGrid(this.gridTarget)
  })

  showLoader = () => {
    this.spinnerTarget.classList.remove('hidden')
  }

  hideLoader = () => {
    this.spinnerTarget.classList.add('hidden')
  }

  blurGrid = () => {
    this.gridTarget.classList.add('gif-processing')
  }

  unblurGrid = () => {
    this.gridTarget.classList.remove('gif-processing')
  }

  onGifSelect = (e) => {
    this.showLoader()
    this.blurGrid()
    const event = new CustomEvent('gif-selected', {
      detail: {
        gifObject: e,
      },
      bubbles: true,
    })
    this.element.dispatchEvent(event)
  }
}
